import { render, staticRenderFns } from "./WeedingForm.vue?vue&type=template&id=351c52b0&scoped=true&lang=html&"
import script from "./WeedingForm.vue?vue&type=script&lang=js&"
export * from "./WeedingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c52b0",
  null
  
)

export default component.exports